(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSwipe(slider) {
    if (slider.dataset.swipeInit === 'true') return;
    slider.dataset.swipeInit = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScrollLeft = 0;

    slider.addEventListener('pointerdown', function (event) {
      // Touch/pen use native scrolling; only enhance mouse with click-drag.
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      if (!moved && Math.abs(delta) > 5) {
        moved = true;
        slider.classList.add('is-dragging');
        // Capture (and cancel native image/link drag-and-drop) only once an
        // actual drag starts — capturing on every pointerdown re-targets the
        // click event to the slider itself and swallows plain product clicks.
        slider.setPointerCapture(event.pointerId);
        event.preventDefault();
      }
      if (moved) {
        slider.scrollLeft = startScrollLeft - delta;
        event.preventDefault();
      }
    });

    function endDrag(event) {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('is-dragging');
      if (event && event.pointerId !== undefined) {
        try {
          slider.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('pointerleave', endDrag);

    // Swallow the click that follows a drag so it doesn't open a product link.
    slider.addEventListener(
      'click',
      function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function initAllSliders(root) {
    root.querySelectorAll('.collection-slider-row .collection-listing.slider').forEach(initSwipe);
  }

  initAllSliders(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAllSliders(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
